import React from 'react';
import './style.css';
import { Link, useNavigate } from 'react-router-dom';
import { setChapterById } from '../../../Store/Actions';
import { useDispatch } from 'react-redux';
import linkedInLogo from '../../../Assets/linkedInLogo.png';
import useLocalization from '../../../Localization';
import { useParams } from 'react-router-dom';
const InitialFooter = ({ chapterList, chapterLogo }) => {
  const { ApplicationString } = useLocalization();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleChapterClick = (chapterId, chapterName) => {
    dispatch(setChapterById(chapterId));
    navigate(`/chapter/${chapterName}`);
  };

  const visibleChapters = chapterList?.filter((chapter) => {
    return chapter?.is_visible_on_map === true;
  });
  const { chapterName } = useParams();
  const linkedInUrl =
    chapterName === 'Japan'
      ? 'https://www.linkedin.com/company/japan-pharmaceutical-bioscience-society/?viewAsMember=true'
      : 'https://www.linkedin.com/company/pbss-international/';
  return (
    <div className='initial-container'>
      <div className='column  icon-container-footer'>
        <img
          src={chapterLogo}
          className='footer-logo-img'
          crossOrigin='anonymous'
          loading='lazy'
          decoding='async'
        />
      </div>
      <div className='column info-container'>
        <p className='column-heading'>
          {ApplicationString['footer.events.title']}
        </p>
        <div className='links-container'>
          {visibleChapters &&
            visibleChapters.map((item) => {
              return (
                <div
                  id={`newsletter-navigation-button-${item.id}`}
                  key={item.name}
                  className='icon-container-footer'>
                  <li>
                    <a
                      onClick={() =>
                        handleChapterClick(item.id, item.normalized_name)
                      }>
                      {item?.name}
                    </a>
                  </li>
                </div>
              );
            })}
        </div>
        <div className='icon-container-footer'>
          <li>
            <Link to={'/'}>PBSS- International</Link>
          </li>
        </div>
      </div>
      {/* <div className='column info-container'>
        <p className='column-heading'>{""}</p>
        <div className='links-container'>
          {chapterList &&
            chapterList.slice(4).map((item) => {
              return (
                <div key={item.name} className='icon-container-footer'>
                  <li>
                    <a onClick={() => handleChapterClick(item.id, item.normalized_name)}>
                      {item?.name}
                    </a>
                  </li>
                </div>
              );
            })}
          <div className='icon-container-footer'>
            <li>
              <Link to={'/'}>PBSS- International</Link>
            </li>
          </div>
        </div>
      </div> */}
      {/* <div className='column info-container'>
        <p className='column-heading'>About</p>
        <div className='links-container'>
          <div
            className='icon-container-footer'
            id='home-iconContainer-button_1'>
            <li>
              <Link to={'/aboutUs'}>About Us</Link>
            </li>
          </div>
          <div
            className='icon-container-footer'
            id='home-iconContainer-button_2'>
            <li>
              <Link to={'/contactUs'}>Contact Us</Link>
            </li>
          </div>
        </div>
      </div> */}
      <div className='column info-container'>
        <p className='column-heading'>
          {ApplicationString['footer.links.title']}
        </p>
        <div className='links-container'>
          <div
            className='icon-container-footer'
            id='home-iconContainer-button_3'>
            <li>
              <Link to={'/aboutUs'}>
                {ApplicationString['footer.links.aboutUs']}
              </Link>
            </li>
          </div>
          <div
            className='icon-container-footer'
            id='home-iconContainer-button_3'>
            <li>
              <Link to={'/contactUs'}>
                {ApplicationString['footer.links.contactUs']}
              </Link>
            </li>
          </div>
          <div
            className='icon-container-footer'
            id='home-iconContainer-button_3'>
            <li>
              <Link to={'/jobs/approved'}>
                {ApplicationString['footer.links.jobs']}
              </Link>
            </li>
          </div>
          <div
            className='icon-container-footer'
            id='home-iconContainer-button_4'>
            <li>
              <Link to={'/ads/approved'}>
                {ApplicationString['footer.links.ads']}
              </Link>
            </li>
          </div>
        </div>
      </div>
      <div className='column info-container'>
        <div className='subscribe-container'>
          <div className='subscribe-form'>
            <a
              target='_blank'
              rel='noreferrer'
              className='subscribe-btn'
              href={'https://eepurl.com/iGGqQc'}
              id='home-newsletter-subscribe-button'>
              {ApplicationString['footer.links.subscribe']}
            </a>
          </div>
          <span className='form-privacy'>
            {ApplicationString['footer.links.privacyPolicy']}
          </span>
          <a
            href={linkedInUrl}
            target='_blank'
            rel='noreferrer'
            className='footer-logo-icon'>
            <img
              src={linkedInLogo}
              className='footer-logo'
              width={449}
              height={150}
              loading='lazy'
              decoding='async'
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default InitialFooter;
